module.exports = __webpack_public_path__ + "static/img/d.0e61c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jeu2/img/d.png
// module id = OqNj
// module chunks = 0